export class ReportVO {
    constructor(
        public user?: any,
        public providerId?: any,
        public mapName?: any,
        public countyArray?: string[],
        public areaCode?: any,
        public mapTitle?: any,
        public programName?: any,
        public mapNameData?: any,
        public activityCountList?: any,
        public activityCodeList?: any,
        public seriesInfo?: any,
        public seriesReportInfo?: any,
        public providerList?: any,
	      public county?: any,
	      public provider?: any,
	      public reportBeginDate?: any,
	      public reportEndDate?: any,
        public totalCount?: number,
        public scheduledCount?: number,
        public assessmentDtCount?: number,
        public wpProvider?: any,
        public cityVO?: any,
        public countyList?: any,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/reports.model.ts